import { z } from 'zod';

export const cdekTokenResponseSchema = z.object({
    access_token: z.string(),
    token_type: z.string(),
    expires_in: z.number(),
    scope: z.string().optional(),
});

export type CdekTokenResponseSchema = z.infer<typeof cdekTokenResponseSchema>;
